
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M8.138 24.454a1.442 1.442 0 00.012-1.898c-.903-.988-.903-2.588 0-3.575 1.867-2.045 1.867-5.354 0-7.398a1.164 1.164 0 00-1.738.013 1.442 1.442 0 00-.012 1.898c.903.988.903 2.588 0 3.575-1.867 2.045-1.867 5.354 0 7.398.485.516 1.26.51 1.738-.013zM12.8 18.941a6.87 6.87 0 001.963 4.838c.342.36.848.503 1.324.375.475-.127.846-.506.971-.992a1.411 1.411 0 00-.368-1.351 4.124 4.124 0 010-5.74c2.613-2.674 2.613-7.003 0-9.677a1.343 1.343 0 00-1.914.014 1.412 1.412 0 00-.013 1.954 4.124 4.124 0 010 5.74 6.87 6.87 0 00-1.963 4.84zM23.088 24.454a1.442 1.442 0 00.012-1.898c-.903-.988-.903-2.588 0-3.575 1.867-2.045 1.867-5.354 0-7.398a1.164 1.164 0 00-1.738.013 1.442 1.442 0 00-.012 1.898c.903.988.903 2.588 0 3.575-1.867 2.045-1.867 5.354 0 7.398.485.516 1.26.51 1.738-.013z"}})])])
          )
        }
      }
    